import { ChangeEventHandler, MouseEventHandler, useEffect, useState } from 'react';
import InputMask from 'react-input-mask';
import classNames from 'classnames';
import { ReactComponent as ClearIcon } from './clearBtn.svg';
import './maskinput.scss';

interface MaskInputProps {

	value: string;
	onChangeValue?: ( value: string ) => boolean | void;
	setValue?: ( value: string ) => void;
	
	isRequired?: boolean;
	readOnly?: boolean;
	disabled?: boolean;
	mask?: string;
	className?: string;
	placeholder?: string;
	maskChar?: string;
	isClearBtn?: boolean
	autoFocus?: boolean;
	onClick?: React.MouseEventHandler<HTMLInputElement>;
}

/**
 * Поле ввода с маской
 */
const MaskInput: React.FC<MaskInputProps> = (props) => {

	const { value, setValue, maskChar = '-', disabled = false, readOnly = false, autoFocus = false, mask= "", 
		className, isClearBtn, placeholder, onClick, onChangeValue 
	} = props;

	const [ tmpValue, setTmpValue ] = useState<string>(value);

	useEffect( () => {
		setTmpValue( value );
	}, [ value ] )

	/** Запоминаем ввод и проверяем, а не пора ли вызвать функцию завершения ввода */
	const onChangeValueHandler:ChangeEventHandler<HTMLInputElement> = ( e ) => {
		e.persist();
		const val = e.target.value;
		if ( !readOnly || val === '' ) {
			setTmpValue( val );
			if ( onCheckComplete( val ) ) {
				e.target.blur();
				if ( !!setValue )
					setValue(val);
			}
		}
	};

	const onCheckComplete = ( val: string ): boolean => {
		if ( !mask ) return true;
		if ( !!onChangeValue )
			return !!onChangeValue(val);
		let pattern = mask.replaceAll( '9', '[0-9]' ).replaceAll( 'a', 'Aa-Zz' ).replaceAll( '*', '*' );
		const regex = new RegExp( pattern );
		// console.log( pattern, regex );		
		return regex.test(val);
	};

	const onClearHandler: MouseEventHandler<HTMLButtonElement> = ( event ) => {
		event.preventDefault();
		event.stopPropagation();
		if ( !!setValue )
			setValue('');
	};

	const hasClearButton = !!isClearBtn && !!value;

	return (
		<div style={{ position: "relative", width: '100%' }}>
			<InputMask
				mask={mask}
				readOnly={readOnly}
				maskChar={maskChar}
				autoFocus={autoFocus}
				onClick={onClick}
				onChange={onChangeValueHandler}
				value={tmpValue}
				className={ classNames('rdc_maskinput', className, { 'readonly': readOnly, 'rdc_maskinput--with-clear': hasClearButton } )}
				type='text'
				disabled={disabled}
				placeholder={placeholder}
			/> 
			{
				hasClearButton &&
				<button 
					className='rdc_maskinput__clear' 
					data-tooltip-id="rdc_tooltip" 
					data-tooltip-content="Сбросить"
					disabled={readOnly}
					onClick={onClearHandler}
				>
					<ClearIcon width={24} height={24} />
				</button>
			}
		</div>
	);
}

export default MaskInput;